var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabicon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99658 1.66602V18.3273",
    stroke: "#C8F22B",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1622 4.16528H7.91426C7.14096 4.16528 6.39934 4.47248 5.85253 5.01928C5.30573 5.56608 4.99854 6.30771 4.99854 7.08101C4.99854 7.85431 5.30573 8.59593 5.85253 9.14274C6.39934 9.68954 7.14096 9.99674 7.91426 9.99674H12.0796C12.8529 9.99674 13.5945 10.3039 14.1413 10.8507C14.6881 11.3975 14.9953 12.1392 14.9953 12.9125C14.9953 13.6858 14.6881 14.4274 14.1413 14.9742C13.5945 15.521 12.8529 15.8282 12.0796 15.8282H4.99854",
    stroke: "#C8F22B",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabicon02);
export default __webpack_public_path__ + "static/media/tabicon02.b936547495840542545eea630814461b.svg";
export { ForwardRef as ReactComponent };